var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sun",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M8.708,18.339V15.156a.693.693,0,0,1,1.385,0v3.183a.693.693,0,0,1-1.385,0ZM15.3,16.067l-2.244-2.221a.646.646,0,0,1,0-.922.663.663,0,0,1,.931,0l2.245,2.221a.648.648,0,0,1,0,.923.665.665,0,0,1-.932,0Zm-12.536,0a.648.648,0,0,1,0-.923L5.01,12.923a.664.664,0,0,1,.932,0,.648.648,0,0,1,0,.922L3.7,16.067a.665.665,0,0,1-.932,0ZM5.146,9.5A4.255,4.255,0,1,1,9.4,13.712,4.238,4.238,0,0,1,5.146,9.5Zm1.31,0A2.945,2.945,0,1,0,9.4,6.585,2.932,2.932,0,0,0,6.457,9.5Zm8.659.686a.686.686,0,0,1,0-1.371h3.217a.686.686,0,0,1,0,1.371Zm-14.448,0a.686.686,0,0,1,0-1.371H3.884a.686.686,0,0,1,0,1.371Zm12.39-4.108a.646.646,0,0,1,0-.923L15.3,2.933a.664.664,0,0,1,.932,0,.648.648,0,0,1,0,.923L13.99,6.077a.664.664,0,0,1-.931,0Zm-8.048,0L2.766,3.856a.648.648,0,0,1,0-.923.664.664,0,0,1,.932,0L5.943,5.154a.648.648,0,0,1,0,.923.665.665,0,0,1-.932,0Zm3.7-2.233V.661a.693.693,0,0,1,1.385,0V3.844a.693.693,0,0,1-1.385,0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sun_icon",
    "data-name": "Sun icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M8.708,18.339V15.156a.693.693,0,0,1,1.385,0v3.183a.693.693,0,0,1-1.385,0ZM15.3,16.067l-2.244-2.221a.646.646,0,0,1,0-.922.663.663,0,0,1,.931,0l2.245,2.221a.648.648,0,0,1,0,.923.665.665,0,0,1-.932,0Zm-12.536,0a.648.648,0,0,1,0-.923L5.01,12.923a.664.664,0,0,1,.932,0,.648.648,0,0,1,0,.922L3.7,16.067a.665.665,0,0,1-.932,0ZM5.146,9.5A4.255,4.255,0,1,1,9.4,13.712,4.238,4.238,0,0,1,5.146,9.5Zm1.31,0A2.945,2.945,0,1,0,9.4,6.585,2.932,2.932,0,0,0,6.457,9.5Zm8.659.686a.686.686,0,0,1,0-1.371h3.217a.686.686,0,0,1,0,1.371Zm-14.448,0a.686.686,0,0,1,0-1.371H3.884a.686.686,0,0,1,0,1.371Zm12.39-4.108a.646.646,0,0,1,0-.923L15.3,2.933a.664.664,0,0,1,.932,0,.648.648,0,0,1,0,.923L13.99,6.077a.664.664,0,0,1-.931,0Zm-8.048,0L2.766,3.856a.648.648,0,0,1,0-.923.664.664,0,0,1,.932,0L5.943,5.154a.648.648,0,0,1,0,.923.665.665,0,0,1-.932,0Zm3.7-2.233V.661a.693.693,0,0,1,1.385,0V3.844a.693.693,0,0,1-1.385,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Sun_icon-2",
    "data-name": "Sun icon",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color",
    transform: "translate(-2.819 -2.55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "color_errors",
    "data-name": "color/errors",
    width: 24,
    height: 24,
    rx: 4,
    fill: "#BDC6D7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/Sun.7a1d3b951b006ba307f3acb3fc9899f2.svg";
export { ForwardRef as ReactComponent };